export default "__VITE_ASSET__lt76WNUx__"